export class ForceAddTagsToFirestore {
	static readonly type = '[Tags] Force Add Tags to Firestore';
}
